// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-reviews .lad-reviews-sidebar--wrapper{padding-right:15px}@media screen and (max-width:1026px){.lad-reviews--wrapper .el-aside{padding-left:20px;padding-right:20px}.lad-reviews--wrapper .el-main{margin-top:20px}}@media screen and (max-width:700px){.lad-reviews--wrapper .el-main{padding-top:0;padding-left:0;padding-right:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
